import { mapGetters } from 'vuex'

export default {
  render () {
    return this.$scopedSlots.default({
      products: this.formattedProducts,
      tag: this.tag
    })
  },
  props: {
    tag: {
      type: Object,
      required: false
    },
    products: {
      type: Array,
      require: true,
      validator: value => 'sku' in value[0]
    },
    img: {
      type: Object,
      require: false
    }
  },
  methods: {
    getImg (sku, options = {}) {
      const imgOptions = {
        bg: 'f2f2f5',
        scale: 1,
        image_number: 5,
        ...this.img,
        ...options
      }
      const query = Object.keys(imgOptions).map(key => `&${key}=${imgOptions[key]}`).join('')
      return `https://dynamic.sungod.co/?sku=${sku}${query}&c=${this.$config.sha}`
    },
    getPartsFromSku: sku => (sku || '-').split('-').slice(1),
    getLensPartFromSku (sku) {
      return this.getPartsFromSku(sku).find(part => part.match(/.{1,2}le_/))
    },
    getFramePartFromSku (sku) {
      return this.getPartsFromSku(sku).find(part => part.match(/.{1,2}f_/))
    },
    getLensPartName ({ sku, lensPart, overrideLensName, lensName }) {
      if (overrideLensName && lensName) return lensName

      lensPart = lensPart || this.getLensPartFromSku(sku)
      return (this.$store.getters['product/allChoices'][lensPart] || {}).name || ''
    },
    buildSwatch (sku, frameSwatchOverride, lensSwatchOverride) {
      return [
        this.getSwatch(frameSwatchOverride || this.getFramePartFromSku(sku)),
        this.getSwatch(lensSwatchOverride || this.getLensPartFromSku(sku))
      ]
    },
    getSwatchIcon (product) {
      return (product.swatchIconOverride || {}).url || null
    },
    shouldShowMinimumPrice (product) {
      const baseSku = this.getBaseSku(product.sku)
      if (!['renegades', 'sierras', 'classics3'].includes(baseSku)) return false
      if (product.limitedEdition) return false
      if (product.sku.includes('-le_')) return false
      return true
    },
    getIsIris (sku) {
      return (sku || '').includes('8IR')
    },
    getIsRecycled (sku) {
      const parts = sku.split('-').slice(1)
      return parts.some(part => (this.allChoices[part] || {}).recycled)
    }
  },
  computed: {
    ...mapGetters({
      priceFromSku: 'product/priceFromSku',
      getSwatch: 'product/choiceButtonStyling',
      getProductName: 'product/productName',
      getImages: 'product/productImages',
      getBaseSku: 'product/baseSKU',
      getMinimumProductPrice: 'product/minimumProductPrice',
      getActivePromoForProduct: 'promo/activePromoForProduct',
      getStockState: 'product/isInStock',
      getPreorderState: 'product/isOnPreorder',
      getPreorderDate: 'product/preorderDate',
      getDelayedDespatchDate: 'product/delayedDespatchDate',
      getIconOverlay: 'product/iconOverlay',
      allChoices: 'product/allChoices'
    }),
    formattedProducts () {
      return this.products
        .map((product) => {
          const {
            sku,
            subTitle = '',
            title = null,
            frameSwatchOverride = null,
            lensSwatchOverride = null
          } = product

          const productName = this.getProductName(sku, false)

          return {
            subTitle,
            title: title || productName, // If not title passed, fallback to product name
            price: this.priceFromSku(sku),
            showMinPrice: this.shouldShowMinimumPrice(product),
            minPrice: this.getMinimumProductPrice(product.sku),
            getImage: options => this.getImg(sku, options),
            swatch: this.buildSwatch(sku, frameSwatchOverride, lensSwatchOverride),
            swatchIcon: this.getSwatchIcon(product),
            isIris: this.getIsIris(sku),
            isRecycled: this.getIsRecycled(sku),
            url: `/shop/redirect?sku=${sku}`,
            sku,
            lensPartName: this.getLensPartName(product),
            promo: this.getActivePromoForProduct(sku),
            inStock: this.getStockState(product.sku),
            onPreorder: this.getPreorderState(product.sku),
            preorderDate: this.getPreorderDate(product.sku),
            delayedDespatchDate: this.getDelayedDespatchDate(product.sku)
          }
        })
    }
  }
}
